import MagicButton from "components/MagicButton/MagicButtonV2"
import { useDispatch, useSelector } from "react-redux"
import { setPageModal } from "store/modules/page"
import BmBigModalV2 from 'componentsBM/BmBigModalV2'

const defaultMessage = "Esti sigur ca vrei sa finalizezi aceasta actiune?"
function ConfirmActionModal(props) {
    const {message, svg, closeAction} = props
    const dispatch = useDispatch()
    const actionToConfirm = useSelector(state => state.page?.actionToConfirm)

    const onClose = () => {
      dispatch(setPageModal())
      if (closeAction) closeAction()
    }

    const onConfirm = () => {
      if (actionToConfirm) {
        actionToConfirm() 
        dispatch(setPageModal())
      }
    }
    return (
        <BmBigModalV2 name="SYS-confirm-action" sysModal title="" className="sys-confirm-action" >
            {svg ?? defaultIllustration}
            <span className="etype-2 message">
            {message ?? defaultMessage}
            </span>
            <div className="flex">
            <MagicButton w={27} h={6.5} label="Anuleaza" outline mr={3}
              onClick={onClose}
            />
            <MagicButton w={27} h={6.5} label="Confirm"
              onClick={onConfirm}
            />
            </div>
        </BmBigModalV2>
    )
}

export default ConfirmActionModal

const defaultIllustration = <svg width="240" height="240" viewBox="0 0 240 240" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="120" cy="120" r="120" fill="#EDF5FF"/>
<path d="M93.3182 109.513H96.5582V123.513H93.3182V109.513ZM99.8807 109.513H103.121V120.873H110.141V123.513H99.8807V109.513ZM111.951 109.513H115.191V120.873H122.211V123.513H111.951V109.513ZM130.066 123.753C128.066 123.753 126.506 123.199 125.386 122.093C124.279 120.986 123.726 119.406 123.726 117.353V109.513H126.966V117.233C126.966 119.739 128.006 120.993 130.086 120.993C131.099 120.993 131.872 120.693 132.406 120.093C132.939 119.479 133.206 118.526 133.206 117.233V109.513H136.406V117.353C136.406 119.406 135.846 120.986 134.726 122.093C133.619 123.199 132.066 123.753 130.066 123.753Z" fill="black"/>
</svg>
